import React from "react";
// another components
import { InformacionPostulacion } from "./InformacionPostulacion";
import { ParticipantesPostulacion } from "./ParticipantesPostulacion";
import { FormularioInscripcion } from "./FormularioInscripcion";

// styled components
import { Modal, Button, Tabs } from "antd";
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";

interface IProps {
  modal: boolean;
  AceptarModal: any;
  postulacion: PostulacionModel;
  descargarArchivo: any;
  lineasConvocatoria: any;
  CancelarModal: any;
  isBeps?: boolean;
}

export const ModalVerPropuesta: React.FC<IProps> = (props: IProps) => {
  return (
      <Modal
        title={
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              {`${props.postulacion.nombre_propuesta}`}
            </div>
            <div style={{ marginRight: '35px' }}>
              {`Código: ${props.postulacion.radicado}`}
            </div>
          </div>
        }
        style={{ top: 20 }}
        visible={props.modal}
        onCancel={props.CancelarModal}
        closeIcon="X"
        width={typeof window !== "undefined" && window.innerWidth < 768 ? "96%" : Math.min(window.innerWidth * 0.8, 1100)}
        footer={[
          <Button key="b_cancelar_modalverpro" className="button-gray-ghost" onClick={props.CancelarModal}>
            CANCELAR
          </Button>,
          <Button key="b_aceptar_modalverpro" className="button-azul-radius" onClick={props.AceptarModal}>
            ACEPTAR
          </Button>,
        ]}
        bodyStyle={{
          padding: 0,
        }}
        maskStyle={{
          backgroundColor: "rgba(31,174,239,0.8)",
          borderRadius: "6px",
        }}
      >
        <Tabs defaultActiveKey="1" className="height-100 width-100 tabs-modal-postulaciones">
          <Tabs.TabPane tab="Información" key="1" className="height-100 font-size-14px font-family-Montserrat-Regular">
            <InformacionPostulacion
              postulacion={props.postulacion}
              descargarArchivo={props.descargarArchivo}
              isBeps={props.isBeps}
              lineasConvocatoria={props.lineasConvocatoria}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Participantes"
            key="2"
            className="height-100 font-size-14px font-family-Montserrat-Regular"
          >
            <ParticipantesPostulacion postulacion={props.postulacion} />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Formulario de inscripción"
            key="3"
            className="height-100 font-size-14px font-family-Montserrat-Regular"
          >
            <FormularioInscripcion postulacion={props.postulacion} lineasConvocatoria={props.lineasConvocatoria} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
  );
};
